import React, { useContext, useEffect } from "react";
import ContactCard from "./ContactCard";
import ContactContext from "../context/ContactContext";

const ContactLists = () => {
  const { contactList, setContactList, updated, page } =
    useContext(ContactContext);

  useEffect(() => {
    fetch(`https://aisensy-server.onrender.com/?page=${page}`)
      .then((data) => {
        return data.json();
      })
      .then(({ contacts }) => {
        setContactList(contacts);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [updated]);

  return (
    <>
      {contactList?.map((contact) => (
        <ContactCard key={contact?._id} contact={contact} />
      ))}
    </>
  );
};

export default ContactLists;
